import React from "react";
import { useQuery } from "@apollo/client";
import { YOUTUBE_PLAYLIST } from "src/gql/queries";
import YouTubeEmbed from "src/components/YouTubeEmbed";

type YouTubePlaylistEmbedProps = {
  playlistId: string;
};

export default function YouTubePlaylistEmbed({ playlistId }: YouTubePlaylistEmbedProps) {
  const { data, loading } = useQuery(YOUTUBE_PLAYLIST, {
    variables: { playlistId: playlistId },
  });

  if (!data || loading) {
    return null;
  }

  if (!data.youtubePlaylist || data.youtubePlaylist.length === 0) {
    return null;
  }

  const id = data.youtubePlaylist[0].videoId;
  const title = data.youtubePlaylist[0].title;

  return (
    <section aria-label="BetQL YouTube playlist">
      <YouTubeEmbed videoId={id} title={title} playlistId={playlistId} />
    </section>
  );
}
